export const UPDATE_ENROLLED_COURSE = 'UPDATE_ENROLLED_COURSE';
export const SET_COURSES_ENROLLED = 'SET_COURSES_ENROLLED';
export const SET_PROCESSING_STATE = 'SET_PROCESSING_STATE';
